const UPDATE_PAYMENT_METHOD_CTA_EVENTS = {
    show: 'update_method_cta_show',
    click: 'update_method_cta_click'
};
export function collectUpdatePaymentMethodCta(action, type) {
    collect(UPDATE_PAYMENT_METHOD_CTA_EVENTS[action], {
        type
    });
}
export const updatePaymentMethodTrackingHandlers = {
    onUpdatePaymentMethodShow: (type)=>{
        collectUpdatePaymentMethodCta('show', type);
    },
    onUpdatePaymentMethodClick: (type)=>{
        collectUpdatePaymentMethodCta('click', type);
    }
};
